import React from 'react';
function CheckboxSquare({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20 12v5.5c0 1.4-1.1 2.5-2.5 2.5h-11A2.5 2.5 0 014 17.5v-11C4 5 5.1 4 6.5 4H17"
      />
      <path strokeLinecap="round" strokeLinejoin="round" d="M20 6.5l-8.3 8.3L8 11" />
    </svg>
  );
}

export default CheckboxSquare;
